import React, { useState } from 'react'
import { useTransition, animated } from 'react-spring'
import ScrollspyNav from "react-scrollspy-nav";
import { connect } from 'react-redux';
import { subtotalSelector, totalCartCountSelector } from '../redux/reducers/cart';
import { useHistory } from 'react-router-dom';
import { formatPrice } from '../common/Functions';


function Footer({ menu, subTotal, totalItems, isPopupOpen, token }) {
    const [isOpen, setIsOpen] = useState(false);
    const history = useHistory();

    const toggle = () => {
        setIsOpen(!isOpen);
    }

    function calculateItemsCount(category) {
        let count = 0;
        if (!category.child_cat) {
            return category.items.length;
        }
        category.child_cat.forEach(element => {
            count = count + element.items.length;
        });
        return count;
    }

    const checkout = () => {
        if (token) {
            history.push("/checkout");
        } else {
            history.push({ pathname: '/login', isCheckout: true });
        }
    }

    const navigate = (id) => {
        let element = document.getElementById(id);
        console.log(element);
        window.scrollTo({
            top: element.offsetTop - 184,
            behavior: "smooth"
        });

    }

    return (
        <footer>
            {!isPopupOpen && menu && menu.length > 0 && <>
                <span className="menu-toggle" onClick={toggle}><span className="fa fa-bars"></span>Menu</span>
                <div className={"menu-popup " + (isOpen === true ? " active" : "")} onClick={toggle}>
                    <div className="menu">

                        <ul>

                            {menu.map(category => <li key={category.cat_id}>
                                <a onClick={() => navigate(category.cat_id)}>{category.category_name}<span className="count">
                                    {calculateItemsCount(category)}
                                </span></a>
                            </li>)}

                        </ul>

                    </div>
                </div>
                {!isPopupOpen && totalItems > 0 && <div className="bottom-action bottom-view-cart" onClick={checkout}>
                    <div className="left">
                        <p className="added-item-count text-white"><span>{totalItems}</span> Item Added</p>
                        <p className="price text-white">{formatPrice(subTotal)} <span className="tax-text"> plus taxes</span></p>
                    </div>
                    <div className="right">
                        <button className="btn-bottom text-white">View Cart <span className="fa fa-long-arrow-right"></span></button>
                    </div>
                </div>}
            </>
            }
        </footer >)
}

const mapStateToProps = (state) => {
    const subTotal = subtotalSelector(state);
    const totalItems = totalCartCountSelector(state);
    const isPopupOpen = state.cart.isPopupOpen;
    const token = state.user.token
    return { subTotal, totalItems, isPopupOpen, token }
}

export default connect(mapStateToProps, {})(Footer)
